import React, { Component } from "react";
import "../InMultiSelect/InMultiSelect.css";
import "./VehicleSelect.scss";
import Dom from "../../../../helpers/Dom";

export const getVehicleList = () => {
  const vehicleMap = window.vehicleMap || {};
  return Object.keys(vehicleMap)
    .filter((key) => key.indexOf("user") === -1)
    .map((key) => {
      const vehicle = vehicleMap[key] || {};
      return {
        id: Number(vehicle.vehicleid || vehicle.id || key),
        vehicleno: vehicle.vehicleno || String(key),
      };
    })
    .filter((vehicle) => vehicle.id)
    .sort((a, b) => String(a.vehicleno).localeCompare(String(b.vehicleno)));
};

class VehicleSelect extends Component {
  constructor(props) {
    super(props);
    this.containerRef = null;
    this.inputRef = null;
    this.state = {
      open: false,
      search: "",
      selectedId: null,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    if (this.containerRef && !this.containerRef.contains(event.target)) {
      this.closeMenu();
    }
  };

  getSelectedVehicle = () =>
    getVehicleList().find((vehicle) => vehicle.id === this.state.selectedId);

  getInputValue = () => {
    if (this.state.open) return this.state.search;
    const selected = this.getSelectedVehicle();
    return selected ? selected.vehicleno : "";
  };

  getPlaceholder = () => {
    if (this.props.data && this.props.data.placeholder) {
      return this.props.data.placeholder;
    }
    return "Search";
  };

  notify = (vehicleId) => {
    if (this.props.data && this.props.data.onSelect) {
      this.props.data.onSelect(vehicleId);
    }
  };

  openMenu = () => {
    const selected = this.getSelectedVehicle();
    this.setState(
      { open: true, search: selected ? selected.vehicleno : "" },
      () => {
        if (this.inputRef) {
          this.inputRef.focus();
          this.inputRef.select();
        }
      }
    );
  };

  closeMenu = () => {
    this.setState({ open: false, search: "" });
  };

  selectVehicle = (vehicleId) => {
    this.setState({ selectedId: vehicleId, open: false, search: "" });
    this.notify(vehicleId);
  };

  handleInputChange = (event) => {
    const search = event.target.value;
    const hadSelection = this.state.selectedId;
    this.setState({ open: true, search }, () => {
      if (!search.trim() && hadSelection) {
        this.setState({ selectedId: null });
        this.notify(null);
      }
    });
  };

  getFilteredVehicles = () => {
    const search = (this.state.search || "").trim().toLowerCase();
    const vehicles = getVehicleList();
    const selected = this.getSelectedVehicle();
    if (
      !search ||
      (selected && search === String(selected.vehicleno).toLowerCase())
    ) {
      return vehicles;
    }
    if (search.length < 3) return vehicles;
    return vehicles.filter((vehicle) =>
      vehicle.vehicleno.toLowerCase().includes(search)
    );
  };

  render() {
    const vehicles = this.getFilteredVehicles();
    const selectedId = this.state.selectedId;

    return (
      <div
        className={Dom.Class({ active: this.state.open }, "InMultiSelect")}
        ref={(ref) => (this.containerRef = ref)}
      >
        <input
          className="inputSelectBox"
          autoComplete="off"
          placeholder={this.getPlaceholder()}
          value={this.getInputValue()}
          ref={(ref) => (this.inputRef = ref)}
          onClick={this.openMenu}
          onChange={this.handleInputChange}
        />
        <button
          type="button"
          className="ims-dd"
          onMouseDown={(event) => event.preventDefault()}
          onClick={() =>
            this.state.open ? this.closeMenu() : this.openMenu()
          }
        >
          <i className="fa fa-caret-down" aria-hidden="true" />
        </button>
        <div className="ims-container">
          <div className="ims-container-scroll">
            {vehicles.length ? (
              vehicles.map((vehicle) => (
                <button
                  type="button"
                  className={Dom.Class(
                    { active: selectedId === vehicle.id },
                    "imsc-item"
                  )}
                  key={vehicle.id}
                  onMouseDown={(event) => {
                    event.preventDefault();
                    this.selectVehicle(vehicle.id);
                  }}
                >
                  {vehicle.vehicleno}
                </button>
              ))
            ) : (
              <div className="imsc-item">No vehicles</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VehicleSelect;
